module.exports = __webpack_public_path__ + "img/JourneyBinderActionBoard.e63a2276.png";